import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { StaticImage } from "gatsby-plugin-image";
import * as React from "react";
import Layout from "../components/layout";
import Seo from "../components/seo";
{/* import Interstitial from "../components/interstitial"; */}

export default function Home() {
  return (
    <Layout>
      {/* Hero */}
      <Container
        className="hero"
        maxWidth="false"
        sx={{
          bgcolor: "primary.main",
          py: 8,
        }}
      >
        <Container maxWidth="md" alignItems="center">
          <Typography
            maxWidth="md"
            component="h1"
            variant="h1"
            align="center"
            color="primary.contrastText"
            paragraph
            gutterBottom
          >
            Why 3Aware?
          </Typography>
        </Container>
      </Container>

      {/* End Hero */}

      {/* Why 3Aware? */}

      <Container
        maxWidth="false"
        sx={{
          bgcolor: "primary",
          py: 8,
        }}
      >
        <Container maxWidth="md" alignItems="center">
          <Typography
            component="h2"
            variant="h2"
            align="center"
            color="text.primary"
            paragraph
            gutterBottom
          >
            Gathering real-world data impacts more than manufacturers.
          </Typography>
          <Typography
            variant="body1"
            align="left"
            color="text.primary"
            paragraph
          >
            Post-market clinical follow-up applies to all medical devices, of
            all classes, and is required under EU MDR with very few exceptions.
            Beyond EUMDR, in 2022, 45% of the original Premarket Approvals
            (PMAs) granted by the FDA require post-approval studies. With
            limited time and resources, manufacturers are forced to make the
            choice of which devices to prioritize.
          </Typography>
          <Typography
            variant="body1"
            align="left"
            color="text.primary"
            paragraph
          >
            Hospitals, providers, and their patients are affected by the entire
            healthcare ecosystem. Physicians are being asked to participate in
            clinical data collection studies on existing, well-established
            devices simply because data is not readily available. The result of
            this is providers spending less time on innovation and patient care.
          </Typography>
          <Typography
            variant="body1"
            align="left"
            color="text.primary"
            paragraph
          >
            When these PMCF needs cannot be met, devices are no longer available
            to the doctors and patients who depend on them. This disparately
            impacts vulnerable populations such as pediatric patients, and those
            with rare conditions.
          </Typography>
          <Typography
            variant="body1"
            align="left"
            color="text.primary"
            paragraph
          >
            3Aware provides aiSurveillance&trade; for medical device manufacturers to
            save time and money by offering Access, Analysis and Alerts of
            real-world clinical data. This approach is faster and more cost
            effective for manufacturers, requires less effort by hospitals and
            their providers which leads to better patient outcomes.
          </Typography>
        </Container>
      </Container>

      <Container
        maxWidth="false"
        sx={{
          bgcolor: "primary.main",
          py: 8,
        }}
      >
        <Container maxWidth="md" alignItems="center">
          <Typography
            component="h2"
            variant="h2"
            align="center"
            color="primary.contrastText"
            paragraph
            gutterBottom
          >
            3Aware is the logical choice.
          </Typography>
          <Typography
            variant="body1"
            align="left"
            color="primary.contrastText"
            paragraph
            gutterBottom
          >
            Pre-market investigations alone do not provide the entire safety and
            performance picture of a medical product, which is why PMS is
            critical. 3Aware allows stakeholders to meet their PMCF needs by
            monitoring device usage and patient outcomes in the real-world for
            less time and cost than other currently available methods.
          </Typography>
          <Box
            sx={{
              // bgcolor: "primary.light",
              bgcolor: "#f7f3ed",
              // py: 8,
              // px: 8,
              borderRadius: "8px",
            }}
          >
            <StaticImage
              src="../images/3Aware_chart.png"
              loading="eager"
              width={1650}
              quality={99}
              formats={["auto"]}
              alt=""
              borderRadius="8px"
            />
          </Box>
        </Container>
      </Container>

      {/* End Why 3Aware? */}
      {/* <Interstitial/> */}
    </Layout>
  );
}

export const Head = () => <Seo title="Why" description="Why you should use 3Aware" />
